import { CanvasElement } from '@/typings/customilyElements/canvasElements';
import { LayerElementsMetadata, ModalImportMode } from '@/typings/layers/layers';

export interface Item {
    id: string;
    thumb: string;
    name: string;
    mode?: ModalImportMode;
}

export enum TreeType {
    SELECT_ALL = 'SelectAll',
    PAGE_EPS = 'PageEps',
    GROUP = 'Group',
    CANVAS_ELEMENT = 'CanvasElement',
    FROM_FILE_ELEMENT = 'FromFileElement',
    FROM_FILE_TEXT_ELEMENT = 'FromFileTextElement',
    FROM_FILE_CURVED_TEXT_ELEMENT = 'FromFileCurvedTextElement',
    FROM_FILE_IMAGE_ELEMENT = 'FromFileImageElement',
    FROM_FILE_IMAGE_PLACEHOLDER_ELEMENT = 'FromFileImagePlaceholderElement',
    FROM_FILE_VECTOR_ELEMENT = 'FromFileVectorElement',
    FROM_FILE_VECTOR_PLACEHOLDER_ELEMENT = 'FromFileVectorPlaceholderElement',
    FROM_FILE_CALENDAR_ELEMENT = 'FromFileCalendarElement',
    FROM_FILE_MAP_ELEMENT = 'FromFileMapElement',
    FROM_FILE_MOON_PHASE_ELEMENT = 'FromFileMoonPhaseElement',
    FROM_FILE_STAR_MAP_ELEMENT = 'FromFileStarMapElement',
    HIDDEN = 'Hidden'
}

export enum LayerType {
    DESIGN = 'design',
    TEMPLATE = 'template',
    PSD = 'psd'
}

export enum Tabs {
    Designs = 0,
    DesignsLayers = 1,
    Templates = 2,
    TemplatesLayers = 3,
    Canva = 4,
    ExternalLayers = 5,
    AmazonFileXLSX = 6,
    AmazonFileJSON = 7
}

export interface TreeItem {
    id?: number | string;
    uuid?: number | string;
    icon: string;
    name?: string;
    paginatedChildren?: TreeItem[];
    children?: TreeItem[];
    type: TreeType;
    zIndex?: number;
    metadata?: LayerElementsMetadata;
}

export interface Group {
    id: string;
    locked: boolean;
    name: string;
    position: number;
    type: string;
    uuid: string;
    visible: boolean;
    zIndex: number;
    parentId: string | null;
}

export interface TemplateProduct {
    id: string;
    CreatedDate: string;
    Deleted: boolean;
    ImportedFrom: string;
    LinkedToStoreProduct: boolean;
    ModifiedDate: string;
    ProductId: number;
    TemplateProduct: string;
    colorMode: string;
    eps: EPS;
    format: string;
    groups: Group[];
    listEPS: EPS[];
    name: string;
    preview: object;
    referenceId: string;
    templateProductId: string;
}

export interface EPS {
    CreatedDate: string;
    EpsId: number;
    MergeOutput: boolean;
    ModifiedDate: string;
    ProductId: number;
    baseEps: string;
    baseImage: string;
    circularTextsEps: CanvasElement[];
    dpi: number;
    exportPPI: number;
    height: number;
    id: number;
    imagePlaceHoldersEps: CanvasElement[];
    mirror: boolean;
    name: string;
    podPlaceholder: object;
    product: object;
    textsEps: CanvasElement[];
    vectorEPSEps: CanvasElement[];
    width: number;
    zIndexEps: number;
    zIndexPreview: number;
}

export const enum ChildrenType {
    Layer = 'Layer',
    Group = 'Group'
}
